type DocsChatApi = {
  toggle: () => void;
};

type OpenListener = (open: boolean) => void;

let supportChatLoading = false;
const openListeners = new Set<OpenListener>();
let openObserver: MutationObserver | null = null;
let observedRoot: Element | null = null;
let watchingReady = false;

function widgetRoot(): Element | null {
  const children = document.body?.children;
  if (!children) return null;
  for (const el of children) {
    const root = el.shadowRoot?.querySelector('.w');
    if (root?.querySelector('.panel')) return root;
  }
  return null;
}

function notifyOpen() {
  const open = observedRoot?.classList.contains('open') ?? false;
  openListeners.forEach(listener => listener(open));
}

function attachOpenObserver() {
  const root = widgetRoot();
  if (!root) return;
  if (root === observedRoot) {
    notifyOpen();
    return;
  }
  openObserver?.disconnect();
  observedRoot = root;
  openObserver = new MutationObserver(notifyOpen);
  openObserver.observe(root, { attributes: true, attributeFilter: ['class'] });
  notifyOpen();
}

function watchWidgetOpen() {
  if (watchingReady) return;
  watchingReady = true;
  window.addEventListener('docs-chat:ready', attachOpenObserver);
  attachOpenObserver();
}

export function subscribeAiSupportChatOpen(listener: OpenListener) {
  openListeners.add(listener);
  watchWidgetOpen();
  listener(observedRoot?.classList.contains('open') ?? false);
  return () => {
    openListeners.delete(listener);
  };
}

export function openAiSupportChat() {
  const docsChat = (window as Window & { DocsChat?: DocsChatApi }).DocsChat;
  if (docsChat) {
    docsChat.toggle();
    return;
  }
  if (supportChatLoading) return;
  supportChatLoading = true;
  const script = document.createElement('script');
  script.src = 'https://widget.webinesh.ir/widget.js';
  script.dataset.project = 'b4a524ca';
  script.dataset.launcher = 'none';
  script.dataset.open = 'true';
  script.onerror = () => {
    supportChatLoading = false;
  };
  document.body.appendChild(script);
}
